// extracted by mini-css-extract-plugin
module.exports = {"emphasizedText":"az_xQ","headline":"az_yQ"};